import { render, staticRenderFns } from "./SettingItem.vue?vue&type=template&id=3a0d6e0a&"
import script from "./SettingItem.vue?vue&type=script&lang=ts&"
export * from "./SettingItem.vue?vue&type=script&lang=ts&"
import style0 from "./SettingItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SettingItem.vue"
export default component.exports